import React from "react"
import { TradingViewContainer, Wrapper } from "./styles"
import OverviewWidget from "../../components/TradingViewWidgets/OverviewWidget"
import MarketDataWidget from "../../components/TradingViewWidgets/MarketDataWidget"

const TradingViewChart = ({ item }) => {
  return (
    <>
      <TradingViewContainer>
        <Wrapper>
          <h1>{item.customFields.title}</h1>
          <OverviewWidget />
          {/* <MarketDataWidget /> */}
        </Wrapper>
      </TradingViewContainer>
    </>
  )
}

export default TradingViewChart
